// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"449":"5158e7f766353d1d","651":"6b0a0a214e3e799c","741":"a83780b663de33f6"}[chunkId] + ".js";
};